import React, { ReactElement } from 'react';
import Modal from '../Modal/Modal';
import { MultiValuesNode } from '../../../types/chartDataTypes';
import { StyledDataTable } from './DataTableModal.styles';
import { addWordBreaks } from '../../helper/strings';

export type DataTableModalProps = {
  dataNode: MultiValuesNode;
  dataColumns: string[];
  firstColumnLabel?: string;
  columnLabels?: {[key: string]: string};
  headlinePrefix?: string;
  onRequestClose: () => void;
  entryClickTargetBuilder?: (entry: MultiValuesNode, column: string) => string | (() => void);
};

const DataTableModal = ({
  dataNode,
  dataColumns,
  firstColumnLabel,
  columnLabels,
  headlinePrefix,
  onRequestClose,
  entryClickTargetBuilder,
}: DataTableModalProps): ReactElement => {
  if (!dataNode) {
    return null;
  }

  let headline = dataNode.name || dataNode.totalLabel;
  if (headlinePrefix) {
    headline = `${headlinePrefix}: ${headline}`;
  }

  return (
    <Modal
      isOpen
      onRequestClose={onRequestClose}
      headline={addWordBreaks(headline)}
    >
      <StyledDataTable
        data={dataNode}
        columnKeys={dataColumns}
        firstColumnLabel={firstColumnLabel}
        columnLabels={columnLabels}
        renderLevelShift={1}
        entryClickTargetBuilder={entryClickTargetBuilder}
      />
    </Modal>
  );
};

export default DataTableModal;
